import { Select } from '@components'
import { APP_MARKET, AppMarket, parseAppMarket, setAppMarketOverride } from '@root/utils/marketHost'
import React from 'react'
import { isWindows } from 'react-device-detect'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const MARKETS = Object.values(AppMarket)

export const AppMarketPicker: React.FC = () => {
  const { t } = useTranslation()

  return (
    <StyledAppMarketPicker>
      <Select
        label={t('components.appMarketPicker.market')}
        value={APP_MARKET}
        onChange={e => {
          const next = parseAppMarket(e.target.value)
          if (next) {
            setAppMarketOverride(next)
          }
        }}
      >
        {MARKETS.map(market => (
          <option key={market} value={market}>
            {isWindows ? '' : t(`flags.${market}`)} {t(`components.appMarketPicker.${market}`)}
          </option>
        ))}
      </Select>
    </StyledAppMarketPicker>
  )
}

const StyledAppMarketPicker = styled.div`
  padding: ${({ theme }) => theme.spacing.sm}rem ${({ theme }) => theme.spacing.sm}rem;
  padding-bottom: 0;

  & > * {
    margin: 0;
  }
`
